export default "__VITE_ASSET__CGNQ_rFI__"